import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useI18n } from "../i18n/I18nContext";
import LanguageSwitcher from "./LanguageSwitcher";
import { LogOut } from "lucide-react";

const COAT = "https://customer-assets.emergentagent.com/job_66cda0d4-d07a-4a92-8bdd-b78d3aba21d7/artifacts/xbhowqoo_ephigie-hayti.jpg";

export default function DashboardLayout({ children, title, navItems = [] }) {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const loc = useLocation();
  const nav = useNavigate();

  return (
    <div data-testid="dashboard-shell" className="min-h-screen flex bg-[#050505]">
      <aside data-testid="dashboard-sidebar" className="w-64 hidden md:flex flex-col border-r border-[#161616] bg-[#040404] sticky top-0 h-screen">
        <Link to="/" className="px-5 py-6 flex items-center gap-3 border-b border-[#141414]">
          <img src={COAT} alt="" className="h-10 w-10 object-contain mix-blend-screen" />
          <div>
            <div className="font-serif text-xl leading-none">Seayisyen</div>
            <div className="overline text-[9px] mt-1">{user?.role || ""}</div>
          </div>
        </Link>

        <nav className="flex-1 py-6 px-3 space-y-1">
          {navItems.map((it) => {
            const active = loc.hash === it.hash || (it.hash === "" && !loc.hash);
            return (
              <button
                key={it.id}
                data-testid={`sidebar-${it.id}`}
                onClick={() => { window.location.hash = it.hash; }}
                className={`w-full text-left px-3 py-2.5 text-sm font-condensed tracking-widest uppercase transition-colors flex items-center gap-3 border-l-2 ${
                  active ? "border-[#d4af37] text-white bg-[#0d0d0d]" : "border-transparent text-neutral-500 hover:text-white hover:bg-[#0a0a0a]"
                }`}
              >
                <it.icon size={16} className={active ? "text-[#d4af37]" : ""} />
                {it.label}
              </button>
            );
          })}
        </nav>

        <div className="p-4 border-t border-[#141414] flex items-center justify-between">
          <div className="text-xs text-neutral-400 truncate max-w-[140px]">{user?.email}</div>
          <button
            data-testid="sidebar-logout"
            onClick={async () => { await logout(); nav("/"); }}
            className="text-neutral-500 hover:text-[#e6192b] transition-colors"
          >
            <LogOut size={16} />
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 bg-[#0a0a0a]">
        <div className="border-b border-[#141414] px-5 md:px-10 py-5 flex items-center justify-between sticky top-0 bg-[#0a0a0a]/90 backdrop-blur z-30">
          <div>
            <div className="overline">{user?.role}</div>
            <h1 className="font-serif text-2xl md:text-3xl">{title}</h1>
          </div>
          <LanguageSwitcher />
        </div>
        <div className="px-5 md:px-10 py-8">
          {children}
        </div>
      </main>
    </div>
  );
}
